import React from "react";

type Props = {
    data: any;
};

const TreatyFormSummary = ({ data }: Props) => {
    return (
        <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3">
            {/* {JSON.stringify(data)} */}

            <div>
                <div className="grid grid-cols-3 gap-6">
                    <div>
                        <span className="block text-sm  text-secondary">
                            Policy Number
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.exisitingOffer?.offer_detail
                                ?.policy_number || "N/A"}
                        </div>
                    </div>
                    <div className="col-span-2">
                        <span className="block text-sm  text-secondary">
                            Insured
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.exisitingOffer?.offer_detail?.insured_by ||
                                "N/A"}
                        </div>
                    </div>
                    <div className="col-span-3">
                        <span className="block text-sm  text-secondary">
                            Cedant
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.exisitingOffer?.insurer
                                ?.insurer_company_name || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Facultative Offer
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.exisitingOffer?.facultative_offer || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Commission
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.exisitingOffer?.commission || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Currency
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data?.exisitingOffer?.offer_detail?.currency ||
                                "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TreatyFormSummary;
